import { useState } from "react";
import {Table, Space, Button, message, Modal} from "antd";
import TypeArticleModalForm from './TypeArticleModalForm';
import TypeArticleService from "../../../services/TypeArticleService";

const getColumns = (showModalForm, showModalDelete, setTypeArticleTarget) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: "100px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
    {
      title: "Acciones",
      key: "action",
      width: "150px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setTypeArticleTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setTypeArticleTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
};
export default function TypeArticles({ list = [], getData, setTypeArticles }) {
  const [typeArticleTarget, setTypeArticleTarget] = useState(null);
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);

  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    TypeArticleService.deleteTypeArticle(typeArticleTarget)
      .then((res) => {
        if (res.data?.success) {
          message.success("Tipo de Artículo eliminado.", 3);
          getData()
            .then((res) => {
              handleCancelDelete();
              setTypeArticles(res);
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error("No se pudo obtener la lista de los Tipos de Articulos.", 5);
            });
        } else {
          message.error(
            "No se pudo eliminar el Tipo de Artículo. " + res.data?.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setTypeArticleTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setTypeArticleTarget(null);
        setIsModalFormVisible(false);
        setTypeArticles(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de los Tipos de Articulos.", 5);
      });
  };

  const handleCancelForm = () => {
    setTypeArticleTarget(null);
    setIsModalFormVisible(false);
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{marginBottom:"1em"}}
      >
        +Registrar nuevo tipo de articulo
      </Button>
    <Table
      columns={getColumns(showModalForm, showModalDelete, setTypeArticleTarget)}
      dataSource={list}
      rowKey="id"
      scroll={{ x: "max-content" }}
    />
     {isModalFormVisible ? (
        <TypeArticleModalForm
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          typeArticleTarget={typeArticleTarget}
        />
      ) : null}
      {isModalDeleteVisible?(
        <Modal
        visible={isModalDeleteVisible}
        title="Eliminar Tipo de Artículo"
        onOk={handleOkDelete}
        onCancel={handleCancelDelete}
        okText="Aceptar"
        cancelText="Cancelar"
      >
        <p>
          ¿Desea eliminar el tipo de Artículo{" "}
          <strong>
            {typeArticleTarget?.name}
          </strong>
          ?
        </p>
      </Modal>
      ):null}
    </>
  );
}
